"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _InfinitePagination = require("./InfinitePagination");
Object.keys(_InfinitePagination).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _InfinitePagination[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _InfinitePagination[key];
    }
  });
});